import { ofType, combineEpics } from 'redux-observable';
import { switchMap, takeUntil, map as rxmap, filter, tap, ignoreElements } from 'rxjs/operators';
import { cx, api, rx } from "../../../../api";
import { formatDateTime, getTimezoneString } from '../../../../misc/misc';
import { resolver } from './resolver';
import { actions } from '../actions';
import { fc, f } from '../../../../../i18n';
import { errorMap } from '../../../actions';

const requestEpic = (action$) => {
	return action$.pipe(
		ofType(actions.locationHistory.request.type),
		switchMap(action =>
			rx(api.reports.locationHistory, action.uri, action.parameters).pipe(
				rxmap(operation => actions.locationHistory.success({ report: operation.response() })),
				errorMap(actions.locationHistory.fail),
				takeUntil(action$.pipe(ofType(actions.locationHistory.cancel.type)))
			)
		)
	)
}

const startPrepareEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.locationHistory.export.type),
		rxmap(action => {
			const state = state$.value.reports.locationHistory;
			resolver.resolve(state.list, !state.hasMore);
			if (state.hasMore) {
				return actions.locationHistory.request({ uri: action.uri, parameters: state.parameters });
			} else {
				return actions.locationHistory.success({});
			}
		})
	)
}

const processPrepareEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.locationHistory.success.type),
		filter(action => {
			const state = state$.value.reports.locationHistory;
			if (state.exporting) resolver.resolve(action.report && action.report.locations, !state.hasMore);
			return state.exporting && state.hasMore;
		}),
		rxmap(action => {
			const state = state$.value.reports.locationHistory;
			return actions.locationHistory.request({ uri: state.uri, parameters: state.parameters });
		})
	)
}

const exportCsvEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.locationHistory.exportProgress.type),
		filter(action => action.progress == 100),
		rxmap(action => {
			const state = state$.value.reports.locationHistory;
			const device = state$.value.devices.map[state.uri];
			// report header
			var csv = '"'
				+ fc('report type')
				+ '",'
				+ fc('generated')
				+ ','
				+ fc('timezone')
				+ ','
				+ fc('device')
				+ ','
				+ fc('since')
				+ ','
				+ fc('until')
				+ ',"'
				+ fc('vicinity range') + ', ' + f('units.m')
				+ '","'
				+ fc('stationary only')
				+ '","'
				+ fc('reverse chronology')
				+ '"\n';
			csv += fc('location history');  // report type
			csv += ',' + formatDateTime(cx.now()); // generated at
			csv += ',' + getTimezoneString(); // timezone at
			csv += ',"' + (device.denomination() || device.uri) + '"';
			csv += ',"' + formatDateTime(state.parameters.timeRange.since) + '"';
			csv += ',"' + formatDateTime(state.parameters.timeRange.until) + '"';
			csv += ',' + state.parameters.areaSize;
			csv += ',' + cx.format.bool(state.parameters.stillOnly);
			csv += ',' + cx.format.bool(state.parameters.timeRange.retrospective);
			csv += "\n\n";
			// content header
			csv += fc('since')
				+ ','
				+ fc('until')
				+ ','
				+ fc('location')
				+ ','
				+ fc('address')
				+ ',"'
				+ fc('vicinity range') + ', ' + f('units.m')
				+ '",'
				+ fc('quantity')
				+ '\n';
			// content
			state.list.forEach(location => {
				csv += '"' + formatDateTime(location.since) + '"';
				csv += ',"' + formatDateTime(location.upTo) + '"';
				csv += ",(" + location.latitude + ";" + location.longitude + ')';
				const entryKey = resolver.key(location.latitude, location.longitude);
				const address = resolver.resolved[entryKey]?.getAddress();
				if (address) csv += ',"' + address.format() + '"';
				else csv += ",";
				csv += ',' + location.areaSize;
				csv += ',' + location.quantity;
				csv += "\n";
			});
			return actions.locationHistory.exportDone({ csv });
		}),
	)
}

const exportClearEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.locationHistory.exportClear.type),
		tap(() => resolver.clear()),
		ignoreElements()
	);
}

const epic = combineEpics(requestEpic, startPrepareEpic, processPrepareEpic, exportCsvEpic, exportClearEpic);

export { epic };
